import React, {Component} from 'react';
import {fetchPcBangNoticeById} from '../../../actions/notices.actions';
import {connect} from 'react-redux';
import moment from 'moment-timezone';
import fetch from 'isomorphic-fetch';
import {parseStringToHtmlAndSanitize} from '../../../util/htmlString';

import './notices.scss';
import {Button, ButtonGroup, Table} from '../../Common/PageComponents';

const stateToProps = state => {
  return {
    notice: state.notices.selectedNotice,
  };
};

class NoticeDetail extends Component {
  componentDidMount() {
    let noticeId = this.props.match.params.noticeId;
    this._incrementReadCount(noticeId);
    this.props.dispatch(fetchPcBangNoticeById(noticeId));
  }

  _incrementReadCount(noticeId) {
    fetch(`${API_URL}/notices/by-notice-id/${noticeId}/read-count`, {
      method: 'PATCH',
    });
  }

  render() {
    let notice = this.props.notice;
    if (!notice || Object.keys(notice).length === 0) {
      return <div></div>;
    }

    return (
      <div>
        <Table theme={'form'} className="notice-detail">
          <colgroup>
            <col width="140" />
            <col width="*" />
            <col width="140" />
            <col width="260" />
          </colgroup>
          <tbody>
            <tr>
              <th style={{textAlign: 'center'}}>제목</th>
              <td colSpan="3">
                <b>{notice.title}</b>
              </td>
            </tr>
            <tr>
              <th style={{textAlign: 'center'}}>등록일</th>
              <td>
                {moment
                  .utc(notice.created)
                  .local()
                  .format('YYYY/MM/DD')}
              </td>
              <th style={{textAlign: 'center'}}>조회수</th>
              <td>{notice.readCount}</td>
            </tr>
            <tr>
              <td style={{padding: '20px', wordBreak: 'break-all', lineHeight: '1.6'}} colSpan="4">
                <p dangerouslySetInnerHTML={parseStringToHtmlAndSanitize(notice.content)}></p>
              </td>
            </tr>
          </tbody>
        </Table>
        <ButtonGroup>
          <Button onClick={() => this.props.history.push('/news/notices')}>목록</Button>
        </ButtonGroup>
      </div>
    );
  }
}

export default connect(stateToProps)(NoticeDetail);
